import { Component } from '@theme/component';
import { debounce } from '@theme/utilities';

/**
 * A custom element that displays a marquee.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} wrapper - The wrapper element.
 * @property {HTMLElement} content - The content element.
 * @property {HTMLElement[]} marqueeItems - The marquee items collection.
 *
 * @extends Component<Refs>
 */
class MarqueeComponent extends Component {
  requiredRefs = ['wrapper', 'content', 'marqueeItems'];

  async connectedCallback() {
    super.connectedCallback();

    const { marqueeItems } = this.refs;
    if (marqueeItems.length === 0) return;

    // Mostrar exactamente 3 copias del contenido
    this.#addRepeatedItems(3);

    // Centrar el wrapper
    this.refs.wrapper.style.justifyContent = 'center';
    this.refs.wrapper.style.width = '100%';
    this.refs.wrapper.style.animation = 'none';
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * @param {number} numberOfCopies
   */
  #addRepeatedItems(numberOfCopies) {
    const { content, marqueeItems } = this.refs;

    if (!marqueeItems[0]) return;

    // Primero limpiar copias existentes, dejar solo el original
    const children = Array.from(content.children);
    for (let i = 1; i < children.length; i++) {
      children[i].remove();
    }

    // Agregar exactamente numberOfCopies - 1 clones (el original ya cuenta como 1)
    for (let i = 0; i < numberOfCopies - 1; i++) {
      const clone = marqueeItems[0].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      content.appendChild(clone);
    }
  }
}

if (!customElements.get('marquee-component')) {
  customElements.define('marquee-component', MarqueeComponent);
}